import { Controller } from "@hotwired/stimulus"

// The extra degree is a new record, so it's left out while the form edits one (the record in recordField).
export default class extends Controller {
  static values = { recordField: String }

  connect() {
    this.sync()
  }

  sync() {
    const editing = !!this.recordField?.value
    const graduateShown = !this.element.parentElement.closest(".tw-hidden")

    this.element.hidden = editing
    this.element.querySelectorAll("input, select, textarea").forEach((field) => {
      field.disabled = editing || !graduateShown
    })
  }

  get recordField() {
    if (!this.hasRecordFieldValue) return null

    return this.element.closest("form")?.querySelector(this.recordFieldValue)
  }
}
